// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2fZJf","actionsCol":"EnrolledClinics_actionsCol__260Bb"};